export default __webpack_public_path__ + "static/media/loader_img.cf2c7fcf.gif";